import {Component, OnInit} from '@angular/core';
import {MenuItem, MessageService} from 'primeng/api';
import {ActivatedRoute, Router} from '@angular/router';
import {RolesMgmtService} from '../../@shared/new-services/roles-mgmt.service';
import {FormArray, FormControl, FormGroup} from '@angular/forms';
import {CacheService} from '../../@shared/services/cache.service';

@Component({
    selector: 'app-add-edit-role-form',
    templateUrl: './add-edit-role-form.component.html',
    styleUrls: ['./add-edit-role-form.component.scss']
})
export class AddEditRoleFormComponent implements OnInit {

    breadcrumbMenuModel: MenuItem[] = [];
    home: MenuItem = {icon: 'pi pi-home', routerLink: '/booking-summary'};
    mode: string;
    roleForm: FormGroup;
    roleModuleAccessListForm: FormArray = new FormArray([]);
    isLoading: boolean;
    displayNewRoleDialog: boolean;
    createRoleForm: FormGroup;
    parentRoles: any;
    loggedInUser = this.cacheService.retrieveParsedResponse('detailedLoggedInUser');


    constructor(private activatedRoute: ActivatedRoute,
                private rolesMgmtService: RolesMgmtService,
                private messageService: MessageService,
                private router: Router,
                private cacheService: CacheService) {
    }

    ngOnInit(): void {
        this.createManageRoleForm();
        this.createNewRoleForm();
        this.getParentRoles();
        this.activatedRoute.queryParams
            .subscribe((params) => {
                this.mode = params?.mode;
                if (this.mode !== 'add') {
                    this.getRoleByRoleId(params?.roleId);
                } else {
                    this.displayNewRoleDialog = true;
                }
            });
    }

    getParentRoles() {
        this.rolesMgmtService
            .getParentRoles()
            .subscribe((parentRoles) => {
                this.parentRoles = parentRoles;
            });
    }

    getRoleByRoleId(roleId: any) {
        this.isLoading = true;
        this.rolesMgmtService
            .getRoleByRoleId(roleId)
            .subscribe((role) => {
                this.isLoading = false;
                this.breadcrumbMenuModel = [
                    {label: 'Roles Management', routerLink: '/roles-management'},
                    {label: (this.loggedInUser?.editRoles ? 'Edit Role : ' : 'View Role : ') + role?.name}
                ];
                this.createManageRoleForm(role);
                role?.roleModuleAccessList?.map((roleModuleAccess) => {
                    this.addRoleModuleAccessForm(roleModuleAccess);
                });
                // tslint:disable-next-line:no-shadowed-variable
            }, (error) => {
                this.isLoading = false;
                this.presentToastMessage('error', error?.message ? error?.message : error);
            });
    }

    createRole() {
        const role = this.createRoleForm.value;
        this.rolesMgmtService.createRole(role)
            .subscribe((roleRes: any) => {
                this.displayNewRoleDialog = false;
                this.router.navigate(['/', 'manage-role'], {
                    queryParams: {
                        mode: 'edit',
                        roleId: roleRes?.roleId
                    }
                });
                // tslint:disable-next-line:no-shadowed-variable
            }, (error) => {
                this.presentToastMessage('error', error?.message ? error?.message : error);
            });
    }

    updateRole() {
        const role = this.roleForm.value;
        const roleModuleAccessList = this.roleModuleAccessListForm.value;
        role.roleModuleAccessList = roleModuleAccessList;
        console.log('Request Payload : ', role);
        this.rolesMgmtService
            .updateRole(role)
            .subscribe((x) => {
                this.presentToastMessage('success', 'Role updated successfully !');
                // tslint:disable-next-line:no-shadowed-variable
            }, (error) => {
                this.presentToastMessage('error', error?.message ? error?.message : error);
            });

    }

    onClickOfCancel() {
        this.router
            .navigate(['/', 'roles-management']);
    }

    presentToastMessage(severity, detail) {
        this.messageService
            .add(
                {
                    severity,
                    summary: 'Roles Management Message',
                    key: 'roles-mgmt-message',
                    detail,
                }
            );
    }

    createNewRoleForm() {
        const assignedParentRole = {
            roleId: 7,
            name: 'ROLE_PORTAL_ADMIN'
        };
        this.createRoleForm = new FormGroup({
            roleId: new FormControl(null),
            name: new FormControl(null),
            isActive: new FormControl(false),
            roleModuleAccessList: new FormControl(null),
            assignedParentRole: new FormControl(null),
        });
    }

    createManageRoleForm(role?: any) {
        this.roleForm = new FormGroup({
            roleId: new FormControl(role?.roleId ? role?.roleId : null),
            name: new FormControl(role?.name ? role?.name : null),
            isActive: new FormControl(!!role?.isActive),
            assignedParentRole: new FormControl(role?.assignedParentRole ? role?.assignedParentRole : null),
        });
    }

    addRoleModuleAccessForm(roleModuleAccess?: any) {
        const roleModuleAccessForm: FormGroup = new FormGroup({
            roleId: new FormControl(roleModuleAccess?.roleId ? roleModuleAccess?.roleId : null),
            roleModuleId: new FormControl(roleModuleAccess?.roleModuleId ? roleModuleAccess?.roleModuleId : null),
            moduleId: new FormControl(roleModuleAccess?.moduleId ? roleModuleAccess?.moduleId : null),
            moduleName: new FormControl(roleModuleAccess?.moduleName ? roleModuleAccess?.moduleName : null),
            isDeleteAllowed: new FormControl(!!roleModuleAccess?.isDeleteAllowed),
            isViewAllowed: new FormControl(!!roleModuleAccess?.isViewAllowed),
            isEditAllowed: new FormControl(!!roleModuleAccess?.isEditAllowed)

        });

        this.roleModuleAccessListForm.push(roleModuleAccessForm);
    }
}
